module.exports = __webpack_public_path__ + "static/media/userAvatarGreen.19c0111c.svg";